// Quick Add to Cart Modal
(function() {
  const modal = document.getElementById('quick-add-modal');
  if (!modal) return;
  
  const overlay = modal.querySelector('.quick-add-overlay');
  const closeBtn = modal.querySelector('.quick-add-close');
  const content = modal.querySelector('.quick-add-content');
  const submitBtn = document.getElementById('quick-add-submit');
  const variantsContainer = document.getElementById('quick-add-variants');
  const errorDiv = document.getElementById('quick-add-error');
  
  let currentProduct = null;
  let selectedVariant = null;
  
  // Abrir modal
  function openModal(productData) {
    currentProduct = productData;
    selectedVariant = null;
    
    // Atualizar informações do produto
    document.getElementById('quick-add-img').src = productData.image;
    document.getElementById('quick-add-img').alt = productData.title;
    document.getElementById('quick-add-title').textContent = productData.title;
    
    // Atualizar preço
    updatePrice(productData.price, productData.comparePrice);
    
    // Carregar variantes
    loadVariants(productData.handle);
    
    // Mostrar modal
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
    
    // Animação
    setTimeout(() => {
      modal.classList.add('active');
    }, 10);
  }
  
  // Fechar modal
  function closeModal() {
    modal.classList.remove('active');
    setTimeout(() => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      variantsContainer.innerHTML = '';
      errorDiv.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adicionar ao Carrinho';
      selectedVariant = null;
    }, 300);
  }
  
  // Atualizar preço
  function updatePrice(price, comparePrice) {
    const priceContainer = document.getElementById('quick-add-price');
    const currentPrice = priceContainer.querySelector('.price-current');
    const compareElement = priceContainer.querySelector('.price-compare');
    
    const formattedPrice = formatMoney(price);
    currentPrice.innerHTML = formattedPrice;
    
    if (comparePrice && comparePrice > price) {
      const formattedCompare = formatMoney(comparePrice);
      compareElement.innerHTML = formattedCompare;
      compareElement.style.display = 'inline-block';
    } else {
      compareElement.style.display = 'none';
    }
  }
  
  // Formatar preço
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return 'R$ ' + value.replace('.', ',');
  }
  
  // Carregar variantes do produto
  function loadVariants(handle) {
    variantsContainer.innerHTML = '<div class="loading">Carregando variantes...</div>';
    
    fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        renderVariants(product);
      })
      .catch(error => {
        console.error('Erro ao carregar variantes:', error);
        variantsContainer.innerHTML = '<div class="error">Erro ao carregar variantes</div>';
      });
  }
  
  // Renderizar variantes
  function renderVariants(product) {
    if (!product.variants || product.variants.length === 0) {
      variantsContainer.innerHTML = '<div class="no-variants">Produto sem variantes</div>';
      return;
    }
    
    // Se tiver apenas uma variante
    if (product.variants.length === 1) {
      selectedVariant = product.variants[0];
      submitBtn.disabled = !selectedVariant.available;
      variantsContainer.innerHTML = selectedVariant.available ? 
        '<div class="variant-available">Produto disponível</div>' : 
        '<div class="variant-unavailable">Produto indisponível</div>';
      return;
    }
    
    // Múltiplas variantes - criar seletor visual
    let html = '<div class="variants-grid">';
    
    product.variants.forEach(variant => {
      const isAvailable = variant.available;
      const image = variant.featured_image ? variant.featured_image.src : product.featured_image;
      const title = variant.title;
      
      html += `
        <div class="variant-option ${!isAvailable ? 'unavailable' : ''}" 
             data-variant-id="${variant.id}"
             data-variant-price="${variant.price}"
             data-variant-compare="${variant.compare_at_price || 0}"
             data-variant-available="${isAvailable}">
          <div class="variant-image">
            <img src="${image}" alt="${title}" loading="lazy">
          </div>
          <div class="variant-title">${title}</div>
          ${!isAvailable ? '<div class="variant-sold-out">Esgotado</div>' : ''}
        </div>
      `;
    });
    
    html += '</div>';
    variantsContainer.innerHTML = html;
    
    // Adicionar event listeners nas variantes
    const variantOptions = variantsContainer.querySelectorAll('.variant-option');
    variantOptions.forEach(option => {
      option.addEventListener('click', function() {
        if (this.dataset.variantAvailable === 'false') return;
        
        // Remover seleção anterior
        variantOptions.forEach(opt => opt.classList.remove('selected'));
        
        // Selecionar nova variante
        this.classList.add('selected');
        
        selectedVariant = {
          id: this.dataset.variantId,
          price: this.dataset.variantPrice,
          comparePrice: this.dataset.variantCompare
        };
        
        // Atualizar preço
        updatePrice(parseInt(selectedVariant.price), parseInt(selectedVariant.comparePrice));
        
        // Habilitar botão
        submitBtn.disabled = false;
      });
    });
  }
  
  // Adicionar ao carrinho
  function addToCart() {
    if (!selectedVariant) {
      showError('Por favor, selecione uma variante');
      return;
    }
    
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adicionando...';
    errorDiv.style.display = 'none';
    
    const formData = {
      items: [{
        id: selectedVariant.id,
        quantity: 1
      }]
    };
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(line_item => {
      if (line_item.status && line_item.status !== 200) {
        const error = new Error(line_item.description);
        error.isFromServer = true;
        throw error;
      }
      
      // Fechar modal
      closeModal();
      
      // Usar a mesma lógica da página de produto
      const productId = line_item.id === undefined ? 19041994 : line_item.product_id;
      
      if (typeof geckoShopify !== 'undefined' && typeof geckoShopify.onCartUpdate === 'function') {
        geckoShopify.onCartUpdate(1, 1, productId);
      }
      
      // Trigger event de sucesso
      if (typeof $ !== 'undefined' && typeof $('body').trigger === 'function') {
        $('body').trigger('CartUpdateSuccess');
      }
    })
    .catch(error => {
      console.error('Erro ao adicionar ao carrinho:', error);
      
      // Usar a mesma função de erro do tema
      if (typeof geckoShopify !== 'undefined' && typeof geckoShopify.onError2 === 'function') {
        geckoShopify.onError2(error);
      } else {
        showError('Erro ao adicionar ao carrinho. Tente novamente.');
      }
      
      submitBtn.disabled = false;
      submitBtn.textContent = 'Adicionar ao Carrinho';
    });
  }
  
  // Mostrar erro
  function showError(message) {
    errorDiv.textContent = message;
    errorDiv.style.display = 'block';
  }
  
  // Event listeners
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('quick-add-btn')) {
      e.preventDefault();
      const btn = e.target;
      const productData = {
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage,
        price: parseInt(btn.dataset.productPrice),
        comparePrice: parseInt(btn.dataset.productComparePrice) || 0,
        available: btn.dataset.productAvailable === 'true'
      };
      openModal(productData);
    }
  });
  
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  submitBtn.addEventListener('click', addToCart);
  
  // Fechar com ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      closeModal();
    }
  });
  
  // Prevenir scroll do body quando modal está aberto
  content.addEventListener('click', function(e) {
    e.stopPropagation();
  });
})();
